import { c as _c } from "react/compiler-runtime";
import { getOrgSkillsBySkillIdOptions, getOrgSkillsOptions } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import { IcoDownload16 } from '@onefootprint/icons';
import type { SkillSummary } from '@onefootprint/request-types/dashboard';
import { Button, Combo } from '@onefootprint/ui';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBuilder } from '../../store/provider';

/** Copies a skill from the org's library into this agent, so later library edits don't change a published agent. */
const ImportSkillMenu = () => {
  const $ = _c(63);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "agentBuilder.skills"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "skillLibrary"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    t: tLibrary
  } = useTranslation("agents", t1);
  const {
    state,
    actions
  } = useBuilder();
  const queryClient = useQueryClient();
  const showRequestErrorToast = useRequestErrorToast();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getOrgSkillsOptions();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: library
  } = useQuery(t2);
  let t3;
  if ($[3] !== state.bundle.skills) {
    t3 = new Set(state.bundle.skills.map(_temp));
    $[3] = state.bundle.skills;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const taken = t3;
  let T0;
  let T1;
  let T2;
  let T3;
  let T4;
  let t10;
  let t11;
  let t12;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== actions || $[6] !== library || $[7] !== open || $[8] !== queryClient || $[9] !== search || $[10] !== showRequestErrorToast || $[11] !== t || $[12] !== tLibrary || $[13] !== taken) {
    t12 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const importable = library?.filter(skill => !taken.has(skill.name)) ?? [];
      if (importable.length === 0) {
        t12 = null;
        break bb0;
      }
      let t13;
      if ($[28] !== actions || $[29] !== queryClient || $[30] !== showRequestErrorToast) {
        t13 = async summary => {
          setOpen(false);
          setSearch("");
          ;
          try {
            const skill_0 = await queryClient.fetchQuery(getOrgSkillsBySkillIdOptions({
              path: {
                skillId: summary.id
              }
            }));
            actions.skills.dropExternal(null, "root", [{
              kind: "folder",
              name: skill_0.name,
              children: skill_0.files
            }]);
          } catch (t14) {
            const error = t14;
            showRequestErrorToast(error);
          }
        };
        $[28] = actions;
        $[29] = queryClient;
        $[30] = showRequestErrorToast;
        $[31] = t13;
      } else {
        t13 = $[31];
      }
      const importSkill = t13;
      T4 = Combo.Root;
      t9 = open;
      t10 = setOpen;
      let t14;
      if ($[32] !== t) {
        t14 = t(_temp2);
        $[32] = t;
        $[33] = t14;
      } else {
        t14 = $[33];
      }
      if ($[34] !== t14) {
        t11 = <Combo.Trigger asChild={true}><Button variant="secondary" size="compact" prefixIcon={IcoDownload16}>{t14}</Button></Combo.Trigger>;
        $[34] = t14;
        $[35] = t11;
      } else {
        t11 = $[35];
      }
      T3 = Combo.Portal;
      T2 = Combo.Content;
      t6 = "center";
      t7 = "360px";
      if ($[36] !== search) {
        t8 = <Combo.Input value={search} onValueChange={setSearch} />;
        $[36] = search;
        $[37] = t8;
      } else {
        t8 = $[37];
      }
      T1 = Combo.List;
      t5 = "";
      T0 = Combo.Group;
      let t15;
      if ($[38] !== importSkill || $[39] !== tLibrary) {
        t15 = skill_1 => {
          const scope = skill_1.isShared ? tLibrary(_temp3) : tLibrary(_temp4);
          return <Combo.Item key={skill_1.id} value={`${skill_1.name}#${skill_1.isShared ? 1 : 0}`} onSelect={() => importSkill(skill_1)}><span className="flex min-w-0 flex-col gap-0.5"><span className="text-label-3 text-primary">/{skill_1.name}</span><span className="line-clamp-2 text-caption-1 text-tertiary">{skill_1.description || tLibrary(_temp5)}</span><span className="text-caption-1 text-quaternary">{scope}</span></span></Combo.Item>;
        };
        $[38] = importSkill;
        $[39] = tLibrary;
        $[40] = t15;
      } else {
        t15 = $[40];
      }
      t4 = importable.map(t15);
    }
    $[5] = actions;
    $[6] = library;
    $[7] = open;
    $[8] = queryClient;
    $[9] = search;
    $[10] = showRequestErrorToast;
    $[11] = t;
    $[12] = tLibrary;
    $[13] = taken;
    $[14] = T0;
    $[15] = T1;
    $[16] = T2;
    $[17] = T3;
    $[18] = T4;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    T0 = $[14];
    T1 = $[15];
    T2 = $[16];
    T3 = $[17];
    T4 = $[18];
    t10 = $[19];
    t11 = $[20];
    t12 = $[21];
    t4 = $[22];
    t5 = $[23];
    t6 = $[24];
    t7 = $[25];
    t8 = $[26];
    t9 = $[27];
  }
  if (t12 !== Symbol.for("react.early_return_sentinel")) {
    return t12;
  }
  let t13;
  if ($[41] !== T0 || $[42] !== t4) {
    t13 = <T0>{t4}</T0>;
    $[41] = T0;
    $[42] = t4;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== T1 || $[45] !== t13 || $[46] !== t5) {
    t14 = <T1 emptyText={t5}>{t13}</T1>;
    $[44] = T1;
    $[45] = t13;
    $[46] = t5;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  let t15;
  if ($[48] !== T2 || $[49] !== t14 || $[50] !== t6 || $[51] !== t7 || $[52] !== t8) {
    t15 = <T2 align={t6} width={t7}>{t8}{t14}</T2>;
    $[48] = T2;
    $[49] = t14;
    $[50] = t6;
    $[51] = t7;
    $[52] = t8;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== T3 || $[55] !== t15) {
    t16 = <T3>{t15}</T3>;
    $[54] = T3;
    $[55] = t15;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  let t17;
  if ($[57] !== T4 || $[58] !== t10 || $[59] !== t11 || $[60] !== t16 || $[61] !== t9) {
    t17 = <T4 open={t9} onOpenChange={t10}>{t11}{t16}</T4>;
    $[57] = T4;
    $[58] = t10;
    $[59] = t11;
    $[60] = t16;
    $[61] = t9;
    $[62] = t17;
  } else {
    t17 = $[62];
  }
  return t17;
};
export default ImportSkillMenu;
function _temp(node) {
  return node.name;
}
function _temp2($) {
  return $.importSkill;
}
function _temp3($_0) {
  return $_0.scope.shared;
}
function _temp4($_1) {
  return $_1.scope.private;
}
function _temp5($_2) {
  return $_2.noDescription;
}